import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 구매 실패 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 죄송합니다.")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 판매자가 팔기를 취소하셨어요")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 더 좋은 매물을 찾아보세요! 🙏 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 확인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box_s, { css: {
        dp:'flex',
        direction:'column',
        justifyContent:'space-between',
        height:'100%',
        px:'20px',
      } }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s),
          _createVNode(_component_ag_box_s, { css: {
          dp:'flex',
          direction:'column',
          alignItems:'center',
          justifyContent:'center',
          height:'500px',
        } }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_img, {
                width: "40px",
                height: "40px",
                src: _ctx.dealInfo.partnershipLogo
              }, null, 8, ["src"]),
              _createVNode(_component_ag_text_s, { css: {
            pt:8,
            typography:'tit16b'
          } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dealInfo.partnershipName) + " 조합원 자격 ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {my:20,typography:'tit24b'} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {color:'gray3', typography:'tit18r', textAlign:'center'} }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s)
        ]),
        _: 1
      }),
      _createVNode(_component_ag_footer, {
        p: "20px",
        mb: "safeAreaBottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            dp: "flex",
            gap: "sp6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                block: "lg",
                corner: "10px",
                width: "100%",
                onClickCapture: _ctx.cancelToBuy
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClickCapture"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}